/*
	Parallax for hero image
*/

var heroImage = document.getElementsByClassName("hero-image")[0];

window.addEventListener("scroll", function () {
    if (heroImage) {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCss1Compat = ((document.compatMode || "") === "CSS1Compat");
        var scrollTop = supportPageOffset
            ? window.pageYOffset
            : isCss1Compat
            ? document.documentElement.scrollTop
            : document.body.scrollTop;

        var toTop = scrollTop * .1;
        heroImage.style.top = toTop + "px";
    }
});